var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VAvatar',{staticClass:"deal-avatar p-1",class:_vm.draft ? 'draft' : '',attrs:{"size":_vm.size}},[(_vm.productType && _setup.DealIcons[_vm.productType])?_c('span',{staticClass:"d-flex items-center justify-center p-0!"},[_c(_setup.FpSvgIcon,{attrs:{"src":_setup.DealIcons[_vm.productType]}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }